// === Upsell-Tracking & Gift-Popup-Trigger ===
document.addEventListener('click', (e) => {
  const link = e.target.closest('a');
  if (!link) return;

  const rawHref = link.getAttribute('href');
  if (!rawHref) return;

  // Absolut/relativ vereinheitlichen
  const url = rawHref.startsWith('http')
    ? new URL(rawHref)
    : new URL(rawHref, window.location.origin);
  const path = url.pathname; // z. B. "/products/kette"

  // Alle Ziel-Produkt-Slugs (Upsells + Gift-Popup)
  const slugs = [
    'kette',
    'brosche',
    'anhanger-henry',
    'schlusselanhanger-mini'
  ];
  const isTargetProduct = slugs.some(slug => path === `/products/${slug}`);

  // Nur aus unseren Komponenten triggern
  const allowedClasses = [
    'dackl-card',
    'dackl-miniupsell__link',
    'gift-cta',
    'gift-item-link'   // 🔥 NEU: klickbare Produktbilder im Gift-Popup
  ];
  const hasAllowedClass = allowedClasses.some(cls => link.classList.contains(cls));

  if (isTargetProduct && hasAllowedClass) {
    localStorage.setItem('dackl_upsell_trigger', 'true');
  }
});

// === Cart Info Popup anzeigen ===
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('cart-info-popup');
  if (!popup) return;

  console.log('✅ Cart Info Popup Script loaded');

  function showPopup() {
    popup.classList.add('active');
    setTimeout(() => popup.classList.remove('active'), 7000);
  }

  const isProductPage = window.location.pathname.includes('/products/');
  const fromUpsell = localStorage.getItem('dackl_upsell_trigger') === 'true';

  // Wenn nicht von Upsell oder Gift-Popup, abbrechen
  if (!isProductPage || !fromUpsell) return;

  // Popup mit leichter Verzögerung anzeigen
  setTimeout(() => {
    showPopup();
    localStorage.removeItem('dackl_upsell_trigger');
  }, 1500);
});

